import React from 'react'

const Spinner = () => {
  return (
    <div className="d-flex flex-row justify-content-center">
      <div className="spinner-border text-primary mt-3" role="status">
        <span className="sr-only"></span>
      </div>
    </div>
  )
}

export default Spinner
